import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';

import AccountsProvider from './accounts/accounts-provider.js';
import CryptoKeysProvider from './keys/keys-provider.js';
import ERC20TokensProvider from './erc20tokens/erc20tokens-provider.js';
import LocalVaultsProvider from './local-vaults/local-vaults-provider.js';
import ProfileProvider from './profiles/profile-provider.js';
import TransactionsProvider from './transactions/transactions-provider.js';


const _getGlobalObject = () => {
	if ( typeof window !== 'undefined' && typeof window.GlobalClass !== 'undefined' && window.GlobalClass ) {
		var _GlobalClass = window.GlobalClass;
	}
	else if (typeof window !== 'undefined') {
		var _GlobalClass = ( window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
	}
	else if (typeof global !== 'undefined') {
		// we are in node js
		var _GlobalClass = ( global && global.simplestore && global.simplestore.Global ? global.simplestore.Global : null);
	}

	if (_GlobalClass)
	return _GlobalClass.getGlobalObject();
};


const getMvcMyDashboard = async () => {
	const Model = require('../../model.js');

	//const model = Model.getObject(); // does not work in webpack (TypeError: "exports" is read-only)
	const _global = _getGlobalObject();
	if (!_global) return;
	const model = _global.getModuleObject('mydashboard-model');

	const mvcmydashboard = await model.getMvcMyDashboard();

	return mvcmydashboard;
};



const getResourceProvider = (resource) => {
	switch (resource) {
		case 'accounts':
			return AccountsProvider;

		case 'cryptoKeys':
			return CryptoKeysProvider;

		case 'transactions':
			return TransactionsProvider;

		case 'erc20tokens':
			return ERC20TokensProvider;

		case 'profile':
			return ProfileProvider;

		case 'local-vaults':
			return LocalVaultsProvider;
	
		default:
			break;
	}
};

export default {
	getList: async (resource, params) => {
		const { page, perPage } = params.pagination;
		const { field, order } = params.sort;

		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();

			if (!mvcmydashboard) return {data: [], total: 0};

			if (Provider.getList)
			return Provider.getList(mvcmydashboard, params);
			else if (Provider.getFullList) {
				let list = await Provider.getFullList(mvcmydashboard);
				let total = list.length;

				// sort first if required
				if (field && order) {
					list.sort((a, b) => { 
						let val_a = a[field];
						let val_b = b[field];

						if (typeof val_a === 'number') {
							if (val_a < val_b) return (order === 'ASC' ? -1 : +1);
							if (val_a > val_b) return (order === 'ASC' ? +1 : -1);
							return 0;
						}
						else if (typeof val_a === 'string' || val_a instanceof String) {
							let res = val_a.localeCompare(val_b);
							return (order === 'ASC' ? +1 * res : -1 * res);
						}
					} );
				}

				// then paginate
				if ((page !== undefined) && (perPage > 0)) {
					if (page > 1) {
						if (list.length > ((page-1) * perPage))
							list = list.slice((page-1) * perPage);
					}

					if (list.length > perPage)
						list = list.slice(0, perPage);
					
				}

				return {data: list, total: total};
		
			}
			else
				return {data: [], total: 0};
		}
		else
			return {data: [], total: 0};
	},

	getOne: async (resource, params) => {
		const { id } = params;

		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();

			if (!mvcmydashboard) return {id};

			if (Provider.getOne)
			return Provider.getOne(mvcmydashboard, params);
			else if (Provider.getFullList) {
				let list = await Provider.getFullList(mvcmydashboard);
				let item = {id};

				for (var i = 0; i < (list ? list.length: 0); i++) {
					if (list[i] && list[i].id === id) {
						item = list[i];
						break;
					}
				}
		
				return {data: item}
		
			}
			else
				return {data: {id}};
		}
		else
			return {data: {id}};
	},

	getMany: async (resource, params) => {
		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();
			return Provider.getMany(mvcmydashboard, params);
		}
		else
			return {data: [], total: 0};
	},

	getManyReference: async (resource, params) => {
		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();
			return Provider.getManyReference(mvcmydashboard, params);
		}
		else
			return {data: [], total: 0};
	},

	update: async (resource, params) => {
		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();
			return Provider.update(mvcmydashboard, params);
		}
		else
			return {data: [], total: 0};
	},

	updateMany: async (resource, params) => {
		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();
			return Provider.updateMany(mvcmydashboard, params);
		}
		else
			return {data: [], total: 0};
	},

	create: async (resource, params) => {
		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();
			return Provider.create(mvcmydashboard, params);
		}
		else
			return {data: [], total: 0};
	},

	delete: async (resource, params) => {
		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();
			return Provider.delete(mvcmydashboard, params);
		}
		else
			return {data: [], total: 0};
	},

	deleteMany: async (resource, params) => {
		const Provider = getResourceProvider(resource);

		if (Provider) {
			const mvcmydashboard = await getMvcMyDashboard();
			return Provider.deleteMany(mvcmydashboard, params);
		}
		else
			return {data: [], total: 0};
	},
};